/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioMioDTO { 
    id?: string;
    tipo_servizio?: ServizioMioDTOTipoServizioEnum;
    tipo_pratica_id?: string;
    tipo_pratica_codice?: string;
    tipo_pratica_titolo?: string;
    comune_id?: string;
    comune_nome?: string;
    data_inizio?: string;
    data_fine?: string;
    ruolo_servizio?: ServizioMioDTORuoloServizioEnum;
}
export enum ServizioMioDTOTipoServizioEnum {
    MENSA = 'MENSA'
};
export enum ServizioMioDTORuoloServizioEnum {
    OP_SCUOLA = 'OP_SCUOLA',
    OP_CENTRO_COTTURA = 'OP_CENTRO_COTTURA'
};



